export default {
  // --- Common ---
  'common.loading': 'Loading…',
  'common.loadingError': 'Failed to load.',

  // --- Error fallback (main.js) ---
  'error.title': 'Error',
  'error.body': 'Something went wrong. Reload the page or contact us.',

  // --- Home ---
  'home.eyebrow': 'Census · by Doodive',
  'home.zone_selector.title': 'Choose your diving zone',
  'home.zone_selector.species_count': '{count} species',

  // --- Marine zones ---
  'zones.mediterranean': 'Mediterranean Sea',
  'zones.red_sea': 'Red Sea',


  'home.title.pre': 'Collaborative survey of ',
  'home.title.em': 'marine wildlife',
  'home.lead': 'Divers, snorkelers: log the species you spot during your dives. Contribute to an open database for marine biologists worldwide.',
  'home.cta.start': 'Start surveying',
  'home.cta.catalog': 'Browse the catalog',
  'home.discover.title': 'Discover',
  'home.status.loading': 'Connecting…',
  'home.status.ok': 'Database connected',
  'home.status.offline': 'Offline (set up .env.local)',
  'home.footer': '© Doodive · Phase 1 · Mediterranean Catalog',

  // --- iNaturalist observations ---
  'detail.fact.observations': 'Observations',
  'detail.fact.observations.value': '{count} observations',

  // --- Invasive species ---
  'species.invasive': 'Invasive species',

  // --- Depth zone ---
  'detail.fact.typical_depth': 'Zone',
  'typical_depth.coastal': 'Coastal',
  'typical_depth.midwater': 'Mid-water',
  'typical_depth.deep': 'Deep',

  // --- Taxonomic categories ---
  'category.all':         'All',
  'category.fish':        '🐠 Fish',
  'category.mollusk':     '🐙 Mollusks',
  'category.coral':       '🪸 Corals',
  'category.crustacean':  '🦀 Crustaceans',
  'category.echinoderm':  '🌟 Echinoderms',
  'category.plant':       '🌿 Algae & Plants',
  'category.mammal':      '🐬 Marine mammals',
  'category.turtle':      '🐢 Sea turtles',
  'category.other':       '· Other',

  // --- Species list ---
  'list.eyebrow': 'Catalog',
  'list.eyebrow_zone': 'Catalog · {zone}',
  'list.title': 'Species to identify.',
  'list.lead': 'Your photographic guide for every dive. Photos under Creative Commons license via iNaturalist.',
  'list.search.placeholder': 'Search (wrasse, grouper, sparus aurata…)',
  'list.danger.toggle': 'Hazardous species',
  'list.empty': 'No species match.',
  'list.count': '{count} species',
  'list.danger.tooltip': 'Danger level: {level}/5',

  // --- Species detail ---
  'detail.notFound.title': 'Species not found',
  'detail.notFound.body': 'This page does not exist or has been removed.',
  'detail.notFound.back': '← Back to catalog',
  'detail.nav.back': '← Catalog',
  'detail.nav.back_swipe': '← Survey',
  'detail.fallback.taxClass': 'Marine species',
  'detail.gallery.aria': 'View photo {n} of {total}',
  'detail.photo.credit': 'Photo:',
  'detail.wikipedia.source': 'Source:',
  'detail.wikipedia.label': 'Wikipedia',
  'detail.wikipedia.license': '· License',
  'detail.fact.size': 'Max size',
  'detail.fact.depth': 'Depth',
  'detail.fact.danger': 'Danger',
  'detail.fact.iucn': 'IUCN status',
  'detail.danger.eyebrow': '⚠ Good to know',
  'detail.taxonomy.eyebrow': 'Classification',
  'detail.section.habitat': 'Habitat',
  'detail.section.diet': 'Diet',
  'detail.section.reproduction': 'Reproduction',
  'detail.external.eyebrow': 'Learn more',

  // --- Danger levels ---
  'danger.0': 'Harmless',
  'danger.1': 'Caution',
  'danger.2': 'Moderate risk',
  'danger.3': 'Dangerous',
  'danger.4': 'Very dangerous',
  'danger.5': 'Extreme',

  // --- IUCN ---
  'iucn.LC': 'Least concern',
  'iucn.NT': 'Near threatened',
  'iucn.VU': 'Vulnerable',
  'iucn.EN': 'Endangered',
  'iucn.CR': 'Critically endangered',
  'iucn.EW': 'Extinct in the wild',
  'iucn.EX': 'Extinct',
  'iucn.DD': 'Data deficient',

  // --- Depth ---
  'depth.upTo': 'up to {max} m',
  'depth.from': 'from {min} m',

  // --- Swipe ---
  'swipe.reset.label': 'Restart',
  'swipe.btn.no.label': 'Not seen',
  'swipe.btn.no.text': 'Not seen',
  'swipe.btn.no.title': 'Not seen (←)',
  'swipe.btn.doubt.label': 'Not sure',
  'swipe.btn.doubt.text': 'Unsure',
  'swipe.btn.doubt.title': 'Not sure (space)',
  'swipe.btn.yes.label': 'Seen',
  'swipe.btn.yes.text': 'Seen',
  'swipe.btn.yes.title': 'Seen (→)',
  'swipe.progress.total': '{count} species',
  'swipe.progress.seenLabel': 'seen',
  'swipe.progress.remaining': '{count} remaining',
  'swipe.empty.eyebrow': 'Well done',
  'swipe.empty.title': `You've gone through all the species.`,
  'swipe.empty.title_filtered': `You've gone through all the {category}.`,
  'swipe.empty.seen': '{count} seen',
  'swipe.empty.doubt': '{count} uncertain',
  'swipe.empty.skipped': '{count} not seen',
  'swipe.empty.catalog': 'Browse the catalog',
  'swipe.empty.restart': 'Start over',
  'swipe.confirm.reset': 'Reset everything?',
  'swipe.confirm.fullReset': 'Start from the beginning? Your current sightings will be lost.',
  'swipe.badge.yes': 'SEEN',
  'swipe.badge.no': 'NOT SEEN',
  'swipe.card.danger': 'Danger {level}/5',
  'swipe.card.more': 'View species →',

  // --- Not found ---
  'notFound.eyebrow': 'Error 404',
  'notFound.title': 'Page not found',
  'notFound.body': `This page doesn't exist or has been removed.`,
  'notFound.back': 'Back to home',

  // --- Navigation globale ---
  'nav.logo': 'Census',
  'header.baseline.line1': 'Collaborative survey',
  'header.baseline.line2': 'of marine wildlife',
  'nav.back.home': 'Home',
  'nav.back.catalog': 'Catalog',
  'nav.back.swipe': 'Survey',
  'nav.back.generic': 'Back',
  'nav.back.species': '{name}',
  'nav.back.results': 'Results',
  'nav.back.region': '{name}',
  'nav.back_home': '← Home',
  'nav.back_home.aria': 'Back to home',
  'nav.home': 'Home',
  'nav.catalog': 'Catalog',
  'nav.survey': 'Survey',
  'nav.help': 'Help',
  'nav.menu.open': 'Open menu',
  'nav.menu.close': 'Close menu',

  // --- Page Aide ---
  'help.eyebrow': 'User guide',
  'help.title': 'How it works',
  'help.back': '← Home',
  'help.s1.title': 'Collaborative species recording',
  'help.s1.body': `Census by Doodive is a citizen science project. Every dive or snorkeling trip is an opportunity to contribute to our understanding of Mediterranean marine biodiversity. Your sightings feed an open database, available to marine biologists and ocean conservation organisations.`,
  'help.s2.title': 'Seen / Not seen swipe',
  'help.s2.body': `On the Survey page, species cards are shown one by one. Swipe right (or tap the SEEN 👁 button on the right) if you've already spotted this species. Swipe left (or tap NOT SEEN 👁‍🗨 on the left) if you've never seen it. The ? button in the middle lets you flag uncertainty. Your answers are stored locally on your device.`,
  'help.s3.title': 'Data and species',
  'help.s3.body': `Your data stays on your device — no account is needed to contribute. Photos come from iNaturalist under Creative Commons licenses; please respect photographer credits. In the field, observe species without disturbing them: good recording starts with respect for the marine environment.`,

  // --- Snackbar ---
  'snackbar.undo': 'UNDO',
  'swipe.snackbar.marked': `{name} marked as "{choice}"`,
  'swipe.snackbar.choice.seen': 'seen',
  'swipe.snackbar.choice.skipped': 'not seen',
  'swipe.snackbar.choice.doubt': 'unsure',

  // --- Footer ---
  'footer.copyright': '© {year} census.doodive.com',

  // --- Profile card ---
  'profile.anonymous': 'Anonymous diver',
  'profile.level.snorkeler': 'Snorkeler',
  'profile.level.open_water': 'Open Water Diver',
  'profile.level.advanced': 'Advanced Diver',
  'profile.level.divemaster': 'Divemaster',
  'profile.level.instructor': 'Instructor',
  'profile.level.biologist': 'Marine Biologist',
  'profile.stats.seen': '{count} species seen',
  'profile.stats.doubt': '{count} uncertain',
  'profile.last_sighting': 'Latest census entry',
  'profile.no_sighting': 'No census entry yet',
  'profile.since': 'Member since {date}',
};
